import { Box, Grid } from "@mui/material";
import { Typography, palette } from "@powerdiary/components-library/lib";
import { DateTime } from "luxon";
import { IDay, slotsForSelectedDay } from "../../AvailabilityShared.helpers";
import styles from "./CalendarDay.module.css";
import PartOfDay from "./PartOfDay";

interface CalendarDayProps {
    day: IDay;
    isSelected: boolean;
    onClick: (date: DateTime) => void;
    dataTestIdSuffix: string;
}

export default function CalendarDay({ day, isSelected, onClick, dataTestIdSuffix }: Readonly<CalendarDayProps>) {
    const { morningSlots, afternoonSlots, eveningSlots } = slotsForSelectedDay(day);

    return (
        <Grid
            className={styles.wrapper}
            data-test-id={`calendar_day_${dataTestIdSuffix}`}
            sx={(theme) => ({
                [theme.breakpoints.down("sm")]: {
                    padding: "4px",
                },
            })}
            size={{ xs: "grow" }}
        >
            {day.availability ? (
                <Box
                    sx={(theme) => ({
                        [theme.breakpoints.down("sm")]: {
                            height: "60px",
                        },
                        border: `1px solid ${palette.neutral["300"]}`,
                        borderRadius: "4px",
                    })}
                    className={`${styles.calendarDay} ${styles.available}  ${isSelected ? styles.selected : ""}`}
                    onClick={() => day.date && onClick(day.date)}
                    data-test-id={`calendar_day_action_${dataTestIdSuffix}`}
                >
                    <Typography
                        variant="paragraphMediumSemiBold"
                        className={styles.dayNumber}
                        data-test-id={`day_number_${dataTestIdSuffix}`}
                    >
                        {day.date?.day}
                    </Typography>
                    <Box className={styles.indicators}>
                        <PartOfDay hasSlots={!!morningSlots} label="Morning" dataTestIdSuffix={dataTestIdSuffix} />
                        <PartOfDay hasSlots={!!afternoonSlots} label="Afternoon" dataTestIdSuffix={dataTestIdSuffix} />
                        <PartOfDay hasSlots={!!eveningSlots} label="Evening" dataTestIdSuffix={dataTestIdSuffix} />
                    </Box>
                </Box>
            ) : (
                <Box
                    className={styles.calendarDay}
                    sx={(theme) => ({
                        backgroundColor: palette.neutral["50"],
                        [theme.breakpoints.down("sm")]: {
                            height: "60px",
                        },
                    })}
                >
                    <Typography
                        variant="paragraphMediumSemiBold"
                        className={styles.dayNumber}
                        data-test-id={`day_number_${dataTestIdSuffix}`}
                    >
                        {day.date ? day.date.day : ""}
                    </Typography>
                </Box>
            )}
        </Grid>
    );
}
